// extracted by mini-css-extract-plugin
export default {"form":"_IX7A7oH","mobile":"mobile","row":"dXVFUylo","phoneGroup":"kdtn62EP","field":"zgFEfINc","phone":"LHHPqlnk","phoneApprove":"gwmMjSff","date":"yU6o2GqE","rules":"a4HGgt0B"};